package com.crowpay.views.components.project.work.changeOrders.mobile

import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.linked
import com.crowpay.utils.resize
import com.crowpay.views.components.project.work.changeOrders.ChangeOrderForm2
import com.crowpay.views.components.project.work.changeOrders.ChangeRequestData
import com.crowpay.views.components.renderPriceChange
import com.crowpay.views.screens.common.ProjectView
import com.crowpay.views.theming.AppColors
import com.crowpay.views.theming.DisplayableStateSemantic
import com.crowpay.views.theming.body
import com.crowpay.views.theming.bodyBold
import com.crowpay.views.theming.colored
import com.crowpay.views.theming.lightSection
import com.lightningkite.kiteui.models.Icon
import com.lightningkite.kiteui.models.times
import com.lightningkite.kiteui.reactive.Readable
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.reactive.reactive
import com.lightningkite.kiteui.reactive.shared
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.centered
import com.lightningkite.kiteui.views.compact
import com.lightningkite.kiteui.views.direct.col
import com.lightningkite.kiteui.views.direct.link
import com.lightningkite.kiteui.views.direct.onlyWhen
import com.lightningkite.kiteui.views.direct.row
import com.lightningkite.kiteui.views.dynamicTheme
import com.lightningkite.kiteui.views.expanding
import com.lightningkite.kiteui.views.l2.icon

fun ProjectView.changeOrderCard(change: Readable<ChangeRequestData>, writer: ViewWriter) = with (writer) {
    lightSection - link {
        col {
            compact - row {
                centered - onlyWhen {
                    change().let { it.status < ChangeRequestData.Status.PartiallyAccepted && it.changeRequest.linkItems }
                } - colored(AppColors.secondary.main) - icon(Icon.linked.resize(AppDimensions.subtitleTextSize * 1.1), "linked")

                centered - expanding - bodyBold {
                    ::content { change().changeRequest.let { "Change #${it.number}: ${it.title}" } }
                }
                centered - bodyBold {
                    dynamicTheme { DisplayableStateSemantic(change().status) }
                    ::content { change().status.displayName }
                }
            }

            body {
                fun Int.withUnit(unit: String) = when (this) {
                    0 -> null
                    1 -> "$this $unit"
                    else -> "$this ${unit}s"
                }

                val str = shared {
                    val c = change()
                    listOfNotNull(
                        c.newItems.size.withUnit("<i>new</i> item"),
                        c.itemChanges.size.withUnit("<i>modified</i> item"),
                        c.itemCancellations.size.withUnit("<i>cancelled</i> item"),
                    )
                        .joinToString(", ")
                        .replaceFirstChar { it.uppercaseChar() }
                }

                ::exists { str().isNotEmpty() }
                reactive { setBasicHtmlContent(str()) }
            }

            compact - row {
                centered - body("Change Amount:")
                centered - renderPriceChange(false) { change().changes.sumOf { it.priceChange ?: 0 } }
            }
        }

        ::to {
            val data = change();
            if (data.status == ChangeRequestData.Status.Draft) {
                { ChangeOrderForm2(projectId, data.changeRequest._id, this@changeOrderCard) }
            }
            else {
                { ChangeOrderDetails(data.changeRequest.project, data.changeRequest._id, lens, this@changeOrderCard) }
            }
        }
    }
}